import React, { Component } from "react";
import { Card, NonIdealState, ButtonGroup, Button } from "@blueprintjs/core";
import { withAuthentication } from "../Session";
import { withRouter, Link, RouteComponentProps } from "react-router-dom";

const GalleryAdd = ({ link }) => {
  return (
    <Link to={link}>
      <Card interactive style={{ width: "192px", height: "192px" }}>
        <NonIdealState
          icon="add"
          action={<Button intent="success">Create new design</Button>}
        />
      </Card>
    </Link>
  );
};

export default GalleryAdd;
